import styled from '@emotion/styled';

/**
 * BulkSelectionBar Emotion Styled Components
 * Compact bar floating at bottom of table data area when rows are selected.
 */

/** Offset from bottom to sit above pagination footer */
const BAR_BOTTOM_OFFSET = '56px';
/** Vertical padding inside the bar (between xxs=4px and xs=8px) */
const BAR_PADDING_Y = '6px';
/** Above table rows, below modals */
const BAR_Z_INDEX = 10;
/** Gap between action buttons */
const ACTIONS_GAP = '6px';
/** Compact rounded corners for icon buttons */
const BUTTON_RADIUS = '6px';

/* Main bar container - floats at bottom center of table area, narrow width */
export const Bar = styled.div`
  position: absolute;
  bottom: ${BAR_BOTTOM_OFFSET};
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  z-index: ${BAR_Z_INDEX};
  display: flex;
  align-items: center;
  gap: ${p => p.theme.s.sm};
  padding: ${BAR_PADDING_Y} ${p => p.theme.s.sm};
  background-color: ${p => p.theme.palette.utility.grey[800]};
  border-radius: ${p => p.theme.s.sm};
  box-shadow:
    0px 4px 8px 0px rgba(0, 0, 0, 0.15),
    0px 1px 3px 0px rgba(0, 0, 0, 0.3);

  .MuiIconButton-root {
    &:hover,
    &:focus {
      background-color: ${p => p.theme.palette.utility.grey[700]};
      color: ${p => p.theme.palette.fg.white};
    }
  }
`;

/* Left section - clear button + selected count */
export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: ${p => p.theme.s.xs};
  padding: 0 ${p => p.theme.s.md};
`;

/* "Selected" text label */
export const SelectedLabel = styled.span`
  font-size: ${p => p.theme.typography.size.xs};
  font-weight: 400;
  white-space: nowrap;
  color: ${p => p.theme.palette.text.placeholderSubtle};
`;

/* Selected count number */
export const SelectedCount = styled.span`
  font-size: ${p => p.theme.typography.size.xs};
  font-weight: 600;
  white-space: nowrap;
  color: ${p => p.theme.palette.text.primaryOnBrand};
`;

/* Vertical divider between count and actions */
export const Separator = styled.div`
  width: 1px;
  height: ${p => p.theme.s.md};
  background-color: ${p => p.theme.palette.border.white};
  flex-shrink: 0;
`;

/* Action icon buttons container */
export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${ACTIONS_GAP};
  color: ${p => p.theme.palette.fg.white};

  .MuiIconButton-root {
    width: ${p => p.theme.s.xxl};
    height: ${p => p.theme.s.xxl};
    border-radius: ${BUTTON_RADIUS};
    color: inherit;

    &.Mui-disabled {
      color: ${p => p.theme.palette.fg.secondary};
      background-color: transparent;

      &:hover,
      &:focus {
        background-color: transparent;
        color: ${p => p.theme.palette.fg.secondary};
      }
    }
  }
`;
